import React, { useState } from 'react';
import { FaRegClipboard, FaCheck } from 'react-icons/fa';
import {Theme} from '../../lib/theme'
interface Props {
  title: string;
  code: Record<string, any>;
}

const CodeBlock: React.FC<Props> = ({ title, code }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    navigator.clipboard.writeText(JSON.stringify(code, null, 2));
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div className="mt-1">
      <h4 className="text-lg font-semibold mb-6 mt-3">{title}</h4>
      <div className="relative mt-2 bg-[#3667B2] rounded-lg">
        <button
          onClick={handleCopy}
          className="absolute top-2 right-2 p-1.5 bg-slate-700 rounded-md hover:bg-slate-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-slate-800 focus:ring-blue-500"
          aria-label="Copy code"
        >
          {copied ? (
            <FaCheck className="h-5 w-5 text-green-400" />
          ) : (
            <FaRegClipboard className="h-5 w-5 text-slate-400" />
          )}
        </button>
        <pre className="p-2 text-sm text-white overflow-x-auto"><code className='text-white'>{JSON.stringify(code, null, 2)}</code></pre>
      </div>
    </div>
  );
};

export default CodeBlock;